import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

export function Home() {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading while checking auth
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  // Redirect authenticated users to Dashboard
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  // Redirect non-authenticated users to About page
  return <Navigate to="/about" replace />;
}
